module.exports = __webpack_public_path__ + "img/iifh.cda6c817.svg";